export class SaasClaudeEnterpriseUserProperties {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "email",
            "baseName": "email",
            "type": "string",
            "format": ""
        },
        {
            "name": "memberships",
            "baseName": "memberships",
            "type": "Array<SaasClaudeEnterpriseMembership>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return SaasClaudeEnterpriseUserProperties.attributeTypeMap;
    }
    constructor() {
    }
}
